import { useLocation as useLocationReachRouter } from '@gatsbyjs/reach-router';
import { LocationContext, LocationContextProps } from 'components/LocationProvider';
import { useContext } from 'react';

import { enhanceHistory } from '../utils/routeUtils';

export type HookedLocation = {
	[P in keyof LocationContextProps]: LocationContextProps[P];
} & { location: Location };

export type UseLocation = ReturnType<typeof useLocationReachRouter> & {
	query?: { [key: string]: string | undefined };
};

export type History = ReturnType<typeof enhanceHistory>;

/**
 * Provides our enhanced `location` and global, but project specific `history`
 */
const useLocation = (): {
	defaultPrivateRoot?: string;
	history?: History;
	location: UseLocation;
	openInNewTab?: (url: string) => void;
} => {
	const locationContext = useContext(LocationContext);
	const location = useLocationReachRouter();
	const patchedLocation = {
		...location,
		query: Object.fromEntries(new URLSearchParams(location.search)),
	};

	return { ...locationContext, location: patchedLocation };
};

export default useLocation;
